/*
 * Pure, DOM-free decision helpers for the Hypemat custom uploader.
 * Loaded in the browser (window.HypematUploaderCore) and require-able in Node tests.
 */
(function (root, factory) {
  const api = factory();
  if (typeof module !== "undefined" && module.exports) {
    module.exports = api;
  } else {
    root.HypematUploaderCore = api;
  }
})(typeof self !== "undefined" ? self : this, function () {
  "use strict";

  function classifyAttachCartResult(status) {
    if (status >= 200 && status < 300) return "success";
    return "retry";
  }

  function attachRetryDelayMs(attempt) {
    const base = 500;
    const max = 4000;
    return Math.min(base * Math.pow(2, Math.max(0, attempt - 1)), max);
  }

  // "left top width height" (fractions of the square mockup side, see
  // snippets/hypemat-format-frame.liquid) -> frame object, or null when blank/invalid.
  function parseArtworkFrame(raw) {
    const parts = String(raw || "")
      .trim()
      .split(/[\s,]+/)
      .filter(Boolean)
      .map(Number);
    if (parts.length !== 4 || parts.some((n) => !Number.isFinite(n))) return null;
    const [left, top, width, height] = parts;
    if (width <= 0 || height <= 0 || left < 0 || top < 0 || left + width > 1 || top + height > 1) return null;
    return { left, top, width, height };
  }

  // Pixel rect of the artwork band inside a wrapper that shows the square mockup with
  // background-size: contain (centred square, side = min(width, height)).
  // With a frame the band sits where the mockup's mat is; without one it is the classic
  // centred full-width band in the format aspect.
  function artworkBandRect(frame, aspectRatio, wrapperWidth, wrapperHeight) {
    if (frame) {
      const side = Math.min(wrapperWidth, wrapperHeight);
      const offsetX = (wrapperWidth - side) / 2;
      const offsetY = (wrapperHeight - side) / 2;
      return {
        left: offsetX + frame.left * side,
        top: offsetY + frame.top * side,
        width: frame.width * side,
        height: frame.height * side,
      };
    }

    let width = wrapperWidth;
    let height = width / aspectRatio;
    if (height > wrapperHeight) {
      height = wrapperHeight;
      width = height * aspectRatio;
    }
    return {
      left: (wrapperWidth - width) / 2,
      top: (wrapperHeight - height) / 2,
      width,
      height,
    };
  }

  return { classifyAttachCartResult, attachRetryDelayMs, parseArtworkFrame, artworkBandRect };
});
